"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const format_1 = require("../../util/format");
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const constants_1 = require("../../constants");
class Sankey {
  constructor(container, tooltip, width, height, scale) {
    this.container = container;
    this.containerWidth = width;
    this.containerHeight = height;
    this.heightScale = scale;
    this.nodeWidths = [width * 0.04, width * 0.7];
    this.linkWidths = [0, width * 0.12];
    this.middlePadding = width * 0.04;
    this.nodeOffset = height * 0.06;
    this.betweenPadding = height * 0.03;
    this.yStart = 50;
    this.levels = 2;
    this.tooltip = tooltip;
  }
  // This is expected to get overridden by inheriting class.
  // eslint-disable-next-line class-methods-use-this
  color(params) {
    return params.primaryColor;
  }
  xOffset(level) {
    const nodeOffset = lodash_1.default.sumBy(this.nodeWidths.map((w, i) => [w, i]), _ref => {
      let [w, i] = _ref;
      return i < level ? w : 0;
    });
    const linkOffset = lodash_1.default.sumBy(this.linkWidths.map((w, i) => [w, i]), _ref2 => {
      let [w, i] = _ref2;
      return i <= level ? w : 0;
    });
    return nodeOffset + linkOffset;
  }
  yAccessor(yOffsetWithPadding, node) {
    if (Object.prototype.hasOwnProperty.call(node, 'padding')) {
      return yOffsetWithPadding - this.betweenPadding + node.padding;
    }
    return yOffsetWithPadding;
  }
  /* eslint-disable */
  xAccessor() {
    return 0;
  }
  xStart() {
    return 0;
  }
  drawLinkLevel() {}
  drawExtra() {}
  /* eslint-enable */
  draw(_ref3, numSankeys, extraValue) {
    let {
      data,
      params
    } = _ref3;
    const rootNode = data;
    const rootKey = Object.keys(rootNode)[0];
    if (extraValue) {
      rootNode.sankey__extra = {
        name: params.extraName,
        total: extraValue,
        padding: 0,
        class: 'sankey-extra',
        pattern: 'sankey-mask-diagonal',
        hideTooltipSubtitle: true
      };
      rootNode[rootKey].children.sankey__extra = {
        name: params.extraName,
        total: extraValue,
        class: 'sankey-extra',
        pattern: 'sankey-mask-diagonal',
        linkClass: 'sankey-extra',
        hideTooltipSubtitle: true,
        excludeFromParentTooltip: true
      };
    }
    this.drawNodeLevel(this.container, rootNode, params, this.yStart, 0, numSankeys, rootNode[rootKey]);
    return this;
  }
  drawNodeLevel(container, nodes, params, yStart, level, numSankeys, fullTotal) {
    const xOffset = this.xOffset(level);
    const start = this.xStart(numSankeys);
    let yOffset = yStart;
    let yOffsetWithPadding = yStart;
    const branchG = container.append('g').classed('sankey-branch', true);
    Object.keys(nodes).forEach(key => {
      const nodeG = branchG.append('g').classed('sankey-node', true);
      const value = nodes[key].total;
      const scaledValue = this.heightScale(Math.abs(value));
      const width = this.nodeWidths[level] / numSankeys;
      const x = this.xAccessor(start, level, numSankeys, width);
      const y = this.yAccessor(yOffsetWithPadding, nodes[key]);
      const rect = nodeG.append('rect').attr('x', x).attr('y', y).attr('width', width).attr('height', scaledValue).attr('fill', value < 0 ? 'rgb(100,100,100)' : this.color(params)).on('mousemove', lodash_1.default.throttle(event => {
        this.showTooltip(nodes[key], params, event, fullTotal);
      }, constants_1.THROTTLE, {
        trailing: false
      }), {
        passive: true
      }).on('mouseout', () => {
        this.tooltip.hide();
      }, {
        passive: true
      });
      nodeG.append('rect').classed('sankey-stroke-rect', true).attr('x', x).attr('y', y).attr('width', width).attr('height', scaledValue).attr('fill', 'none').attr('stroke', value < 0 ? 'rgb(100,100,100)' : this.color(params));
      if (nodes[key].class) {
        rect.classed(nodes[key].class, true);
      }
      if (nodes[key].pattern) {
        rect.attr('mask', `url(#${nodes[key].pattern})`);
      }
      if (level > 0) {
        const textX = this.xLabel(start, level, numSankeys, width);
        this.drawLabel(nodeG, textX, y, scaledValue, nodes[key]);
        const offsets = {
          xOffset,
          yOffset,
          yOffsetWithPadding: y
        };
        this.drawLinkLevel(branchG, nodes[key], params, offsets, level, numSankeys);
      }
      if (level < this.levels - 1 && nodes[key].children) {
        this.drawNodeLevel(branchG, nodes[key].children, params, yOffset + this.nodeOffset, level + 1, numSankeys, fullTotal);
      }
      const addToOffset = value > 0 ? scaledValue : 0;
      const addPadding = Object.prototype.hasOwnProperty.call(nodes[key], 'padding') ? nodes[key].padding : this.betweenPadding;
      yOffset += addToOffset;
      yOffsetWithPadding += addToOffset + addPadding;
    });
    return branchG;
  }
  // eslint-disable-next-line class-methods-use-this
  drawLabel(nodeG, x, y, categoryHeight, datum, textAnchor) {
    const strokeWidth = 1;
    const textBackground = nodeG.append('rect').classed('text-background', true);
    const nodeText = nodeG.append('text').attr('x', x).attr('y', y + categoryHeight / 2).style('text-anchor', textAnchor || 'start').text(datum.name);
    const textBox = nodeText.node().getBBox();
    textBackground.attr('x', x - 5 - (textAnchor === 'end' ? textBox.width : 0)).attr('y', y - strokeWidth).attr('width', textBox.width + 10).attr('height', textBox.height).style('fill', textBox.height > categoryHeight + strokeWidth * 2 ? 'white' : null);
  }
  showTooltip(d, params, event, fullTotal) {
    const containerDim = this.container.node().getBoundingClientRect();
    const {
      clientX: mouseX,
      clientY: mouseY
    } = event;
    const x = mouseX - containerDim.left;
    const y = mouseY - containerDim.top;
    const rows = [];
    if (d.children) {
      Object.entries(d.children).forEach(_ref4 => {
        let [key, node] = _ref4;
        if (node.excludeFromParentTooltip) {
          return;
        }
        rows.push({
          type: 'keyValueLeft',
          key,
          value: format_1.VALUE_FORMATS.dollars(node.total)
        });
        rows.push({
          type: 'bar',
          key,
          value: node.total / d.total
        });
      });
    }
    const percentOfTotal = d.total / fullTotal.total;
    const topContent = {
      title: {
        value: d.name,
        colour: common_module_scss_1.default.chartTitleSecondaryColor
      },
      total: {
        value: format_1.VALUE_FORMATS.dollars(d.total, {
          suffixLength: 'long'
        })
      }
    };
    if (fullTotal.name !== d.name && !d.hideTooltipSubtitle) {
      topContent.subtitle = {
        value: `${format_1.VALUE_FORMATS.percent(percentOfTotal)} of Total ${fullTotal.name}`
      };
    } else {
      delete topContent.subtitle;
    }
    this.tooltip.draw(x, y, topContent, rows, {
      primaryColour: this.color(params),
      secondaryColour: this.color(params)
    });
  }
}
exports.default = Sankey;